// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-chart .chart-element[data-v-489bce79] {
  height: calc(100% - 40px);
}
.bar-chart .pagination[data-v-489bce79] {
  margin: 0;
  padding: 10px 20px;
}
.bar-chart .pagination .page-number[data-v-489bce79] {
  padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/dashboardContainer/src/panels/BarChart.vue","webpack://./BarChart.vue"],"names":[],"mappings":"AAEE;EACE,yBAAA;ACDJ;ADGE;EACE,SAAA;EACA,kBAAA;ACDJ;ADEI;EACE,eAAA;ACAN","sourcesContent":["\n.bar-chart {\n  .chart-element {\n    height: calc(100% - 40px);\n  }\n  .pagination {\n    margin: 0;\n    padding: 10px 20px;\n    .page-number {\n      padding: 0 20px;\n    }\n  }\n}\n",".bar-chart .chart-element {\n  height: calc(100% - 40px);\n}\n.bar-chart .pagination {\n  margin: 0;\n  padding: 10px 20px;\n}\n.bar-chart .pagination .page-number {\n  padding: 0 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
